module.exports = __webpack_public_path__ + "img/icon_point2-7.89ef6e83.svg";